import React from "react";
import { makeStyles } from "@material-ui/core";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import {
  COURSE_HOUSING_TYPES,
  COURSE_TYPES,
} from "../../../language-course/constants";
import { useQuery } from "react-query";
import useLanguageCourseQueries from "../../../language-course/hooks/useLanguageCourseQueries";

const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 21,
  },
}));

const FilterFormCourse = () => {
  const classes = useStyles();

  const { fetchCountriesContainingCourses, fetchLanguagesContainingCourses } =
    useLanguageCourseQueries();

  const {
    isLoading: isLoadingCountries,
    isFetching: isFetchingCountries,
    data: { data: countries } = {},
  } = useQuery<any>(
    "countriesContainingCourses",
    fetchCountriesContainingCourses,
  );

  const {
    isLoading: isLoadingLanguages,
    isFetching: isFetchingLanguages,
    data: { data: languages } = {},
  } = useQuery<any>(
    "languagesContainingCourses",
    fetchLanguagesContainingCourses,
  );

  return (
    <>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="course.language"
          label="Language"
          placeholder="Language"
          options={languages}
          disabled={isLoadingLanguages || isFetchingLanguages}
          disableCloseOnSelect
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          multiple={true}
          name="course.countries"
          label="Branches Country"
          placeholder="Country"
          options={countries}
          disabled={isLoadingCountries || isFetchingCountries}
          disableCloseOnSelect
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="course.courseType"
          label="Course Type"
          placeholder="Please Select"
          options={COURSE_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="course.housingType"
          label="Housing Type"
          placeholder="Please Select"
          options={COURSE_HOUSING_TYPES}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(FilterFormCourse);
